/*
 * Contact-form submission (SPEC §7.1.4 / §9). Writes to the Firestore `messages`
 * collection when configured: { name, email, message, createdAt, read, archived }.
 * Falls back to a console log so the UI flow still works without Firebase.
 */
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export async function sendMessage({ name, email, message }) {
  const payload = { name: name.trim(), email: email.trim(), message: message.trim() };

  if (!db) {
    // eslint-disable-next-line no-console
    console.info('[contact] message (no Firebase configured):', payload);
    await new Promise((r) => setTimeout(r, 400));
    return { ok: true };
  }

  await addDoc(collection(db, 'messages'), {
    ...payload,
    read: false,
    archived: false,
    createdAt: serverTimestamp(),
  });
  return { ok: true };
}
